import { Box, Divider } from '@byecode/ui'
import type { AggregatorNode, UnionField } from '@lighthouse/shared'
import produce from 'immer'
import { find } from 'rambda'
import React, { useCallback, useMemo } from 'react'

import * as SC from './styles'
import { UnionItem } from './UnionItem'

interface UnionMapProps {
    primaryDsNode: AggregatorNode
    unionDsNode: AggregatorNode
    value: UnionField[]
    onChange: (value: UnionField[]) => void
}

export const UnionMap: React.FC<UnionMapProps> = ({ primaryDsNode, unionDsNode, value, onChange }) => {
    const unionFieldList = useMemo(() => {
        return unionDsNode.data.result?.fieldList || []
    }, [unionDsNode])

    const unionFieldIds = useMemo(() => value?.map(item => item.unionFieldId) || [], [value])

    const handleChange = useCallback(
        (val: string, index: number) => {
            const unionMap = produce(value || [], draft => {
                draft[index].unionFieldId = val
            })
            onChange(unionMap)
        },
        [onChange, value]
    )

    const handleDelete = useCallback(
        (index: number) => {
            const unionMap = value.filter((_, i) => i !== index)
            onChange(unionMap)
        },
        [onChange, value]
    )

    return (
        <SC.List>
            <SC.ListItem>
                <SC.Cell>{primaryDsNode.data.config.name}</SC.Cell>
                <SC.Operator>
                    <SC.Line />
                </SC.Operator>
                <SC.Cell>{unionDsNode.data.config.name}</SC.Cell>
                <Box style={{ width: 32 }} />
            </SC.ListItem>
            <Divider />
            {value?.map((item, index) => {
                const primaryField = find(field => field.id === item.primaryFieldId, primaryDsNode.data.result?.fieldList || [])
                return (
                    <>
                        <UnionItem
                            primaryField={primaryField}
                            unionFieldList={unionFieldList}
                            unionFieldIds={unionFieldIds}
                            value={item.unionFieldId}
                            disabledDelete={value?.length === 1}
                            onChange={val => handleChange(val, index)}
                            onDelete={() => handleDelete(index)}
                        />
                        <Divider />
                    </>
                )
            })}
        </SC.List>
    )
}
